import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
        }

        const offices_contact_page = document.querySelector('.select-office__widget');
        if (offices_contact_page) {
            this.loadLocationsWidget(offices_contact_page);
            offices_contact_page.addEventListener('change', () => this.loadLocationsWidget(offices_contact_page));
        }

        this.stickyHeader();
    },

    /**
     * Sticky Header
     *
     * Uses `position: sticky` (no layout shift) and an IntersectionObserver
     * on a sentinel element to add the `is-stuck` class once the header has
     * scrolled to the top, enabling shadow/visual changes without CLS.
     */
    stickyHeader() {
        const header = document.querySelector('.header--sticky');
        if (!header) return;

        const sentinel = document.querySelector('.sticky-sentinel');
        if (!sentinel) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                header.classList.toggle('is-stuck', !entry.isIntersecting);
            },
            { threshold: [0] }
        );

        observer.observe(sentinel);
    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeMap = document.querySelector('.office-map-container');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    calls_number,
                    location_fax,
                    footer_map_desktop,
                    footer_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span class="address__line-1 d-block">${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span class="address__line-2 d-block">${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="address__contact-no ctm-no-swap d-block" aria-label="Phone">${phone}</a>` :
                    '';
                const toll_freeHTML = toll_free_number ?
                    `<a href="tel:${toll_free_number}" class="address__contact-no ctm-no-swap d-block" aria-label="Toll Free Number">Toll Free: <strong>${toll_free_number}</strong></a>` :
                    '';
                const faxHTML = location_fax ?
                    `<a href="tel:${location_fax}" class="address__contact-no ctm-no-swap d-block" aria-label="Fax">Fax: <strong>${location_fax}</strong></a>` :
                    '';
                const calllsHTML = calls_number ?
                    `<a href="tel:${calls_number}" class="btn btn--calls ctm-no-swap" aria-label="Calls Answered 24/7"><span>Calls Answered 24/7</span></a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a class="btn btn--office-btn" href="${directionURL}" target="_blank" aria-label="Get Directions Link"><span>Get Directions</span></a>
                   <button class="btn btn--office-btn cw-modal" data-cw-target="#hoursModal" id="office-hours" aria-label="Office Hours Link">Office Hours</button>
               </div>`;

                const footerMapHTML = footer_map || footer_map_desktop ?
                    `<figure class="footer-map text-center"><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img class="footer-map__img" src="${footer_map}" alt="${firmName}" width="301" height="169"/><img class="footer-map__img-desktop" src="${footer_map_desktop}" alt="${firmName}" width="520" height="292"/></a></figure>` :
                    '';

                const address = `
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span>
               </address>
               ${toll_freeHTML}
               ${faxHTML}
               ${calllsHTML}
               ${officeInfoButtons}`;
                officeBox.innerHTML = address;
                officeMap.innerHTML = footerMapHTML;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

     /**
     * Load Locations for Contact Page
     */
    async loadLocationsWidget(locationID_Widget) {
        if (locationID_Widget) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID_Widget.value}/`;
            const officeBox = document.querySelector('.office-info__widget');
            const officeMap = document.querySelector('.office-map__widget--container');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    calls_number,
                    location_fax,
                    footer_map_desktop,
                    footer_map,
                    contact_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span class="address__line-1 d-block">${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span class="address__line-2 d-block">${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="address__contact-no ctm-no-swap d-block" aria-label="Phone">${phone}</a>` :
                    '';
                const toll_freeHTML = toll_free_number ?
                    `<a href="tel:${toll_free_number}" class="address__contact-no ctm-no-swap d-block" aria-label="Toll Free Number">Toll Free: <strong>${toll_free_number}</strong></a>` :
                    '';
                const faxHTML = location_fax ?
                    `<a href="tel:${location_fax}" class="address__contact-no ctm-no-swap d-block" aria-label="Fax">Fax: <strong>${location_fax}</strong></a>` :
                    '';
                const calllsHTML = calls_number ?
                    `<a href="tel:${calls_number}" class="btn btn--calls ctm-no-swap" aria-label="Calls Answered 24/7"><span>Calls Answered 24/7</span></a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__widget--buttons">
                   <a class="btn btn--office-btn" href="${directionURL}" target="_blank" aria-label="Get Directions Link"><span>Get Directions</span></a>
                   <button class="btn btn--office-btn cw-modal" data-cw-target="#hoursModal" id="office-hours" aria-label="Office Hours Link">Office Hours</button>
               </div>`;

                const contactMapHTML = contact_map ?
                    `<figure class="contact-map mb-0 text-center text-xl-start"><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img class="contact-map__img" src="${contact_map}" alt="${firmName}" /></a></figure>` :
                    '';

                const address = `
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span>
               </address>
               ${toll_freeHTML}
               ${faxHTML}
               ${calllsHTML}
               ${officeInfoButtons}`;
                officeBox.innerHTML = address;
                officeMap.innerHTML = contactMapHTML;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Unified Theme Menu (Handles both Mobile and Tablet)
     */
    initMenu() {
        const menuButton = document.querySelector('.mobile-button, .tablet-button');
        const menuElement = document.querySelector('#mmenu');
        const menuChecker = document.querySelector('.mm-ocd');

        if (menuElement) {
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!menuChecker) {
                    const menu = new MmenuLight(menuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Listen to clicks on whichever button is currently visible/clicked
                    document.addEventListener('click', (event) => {
                        if (event.target.closest('.mobile-button, .tablet-button')) {
                            drawer.open();
                        }
                        if (event.target.closest('.close__mobileMenu, .close__tabletMenu')) {
                            drawer.close();
                        }
                    });

                    // Handle hash tags
                    const aHashTag = menuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    }
    
};

export default CwThemeFramework;